import React from 'react';
import './App.css';
import CoachingInquiryForm from './components/CoachingInquiryForm';

function App() {
  return (
    <div className="App">
      <CoachingInquiryForm />
    </div>
  );
}

export default App;
